import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  CircularProgress,
  FormGroup,
  Snackbar,
  Typography,
  FormHelperText
} from "@mui/material";
import { getEditModalStyles } from "../SiteManagement/styles"; //TODO export these higher
import MuiAlert from '@mui/material/Alert';

export class ModalMessageSettings {
  open: boolean = false;
  message: string = "";
  severity: 'error' | 'info' | 'success' | 'warning' | undefined;
}

export const getResultMessage = (
  result: any,
  defaultSuccessMsg: string,
  defaultErrorMsg?: string
): ModalMessageSettings => {
  if (result && typeof result !== "string") {
    return {
      open: true,
      message: defaultSuccessMsg,
      severity: "success",
    };
  } else {
    return {
      open: true,
      message: result ?? defaultErrorMsg,
      severity: "error",
    };
  }
};

export const InputLengthHelperText = ({ str, maxLength = 255 }: { str: string | undefined; maxLength?: number}) => {
  if (!str || str.length <= maxLength) {
    return <></>;
  }

  return (
    <FormHelperText sx={{ color: 'red' }}>
      Use between 1 and {maxLength} chars.
    </FormHelperText>
  );
};

interface FormModalProps {
  isOpen: boolean;
  title: string;
  description: string;
  isLoading?: boolean;
  handleClose: () => void;
  message?: ModalMessageSettings;
  children: React.ReactNode;
}

export default function FormModal({
  isOpen,
  title,
  description,
  isLoading,
  handleClose,
  children,
  message,
}: FormModalProps) {
  const theme = useTheme();
  const styles = getEditModalStyles(theme);
  const [messageIsOpen, setMessageIsOpen] = useState<boolean>(false);

  useEffect(() => {
    setMessageIsOpen(!!(message?.open));
  }, [message]);

  return (
    <Modal
      aria-labelledby="admin-modal-title"
      aria-describedby="admin-modal-description"
      open={isOpen}
      onClose={(_event, reason) => {
        if (reason !== "backdropClick") {
          setMessageIsOpen(false);
          handleClose();
        }
      }}
      sx={{
        overflow: "scroll",
      }}
    >
      <Box sx={[styles.paper, styles.editModal]}>
        <Typography variant="h5" id="admin-modal-title">
          {title}
        </Typography>
        <Typography variant="body2" gutterBottom id="admin-modal-description">
          {description}
        </Typography>
        <FormGroup>
          {isLoading ? <CircularProgress color="primary" /> : undefined}
        </FormGroup>
        {children}
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={messageIsOpen}
          autoHideDuration={5000}
          onClose={() => setMessageIsOpen(false)}
        >
          <MuiAlert
            severity={message?.severity}
            elevation={6}
            variant="filled"
            onClose={() => setMessageIsOpen(false)}
          >
            {message?.message}
          </MuiAlert>
        </Snackbar>
      </Box>
    </Modal>
  );
}